import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, restDelta: 0.001 });
  return (
    <motion.div
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 z-[60] h-[3px] origin-left"
      data-testid="scroll-progress"
    >
      <div className="h-full w-full" style={{ background: "linear-gradient(90deg, #00C3FF, #FF7A00)" }} />
    </motion.div>
  );
};
